import React, { Component } from "react";
import "./CurrentlyWorking.css";
import Favicon from "react-favicon";
import ReactFitText from "react-fittext";

const secondsToTime = sec => {
  const min = Math.floor(sec / 60);
  const remainingSec = Math.floor(sec % 60);
  return `${min}:${remainingSec < 10 ? "0" : ""}${remainingSec}`;
};

class CurrentlyWorking extends Component {
  componentDidMount() {
    this.timer = setInterval(() => {
      this.forceUpdate();
    }, 1000);
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  render() {
    const { currentPom } = this.props;
    const { stop, topic } = currentPom || {};

    let className = "";
    let message = "Not sure if Christian is working...";
    let secondsLeft = null;

    if (stop) {
      const now = new Date();
      secondsLeft = (stop - now) / 1000;

      if (secondsLeft < 0) {
        message = `Christian is finishing working on ${topic}...`;
      } else {
        message = `Christian is working on ${topic} for ${secondsToTime(
          secondsLeft
        )}`;
      }
      className = "working";
    } else if (currentPom) {
      className = "notWorking";
      message = "Christian is not working.";
    }

    return (
      <div
        className={["currentlyWorkingContainer", className].join(" ")}
        style={{ padding: 20 }}
      >
        <ReactFitText compressor={0.9}>
          <div className="message">{message}</div>
        </ReactFitText>
        {secondsLeft && (
          <Favicon
            url={["favicon-16x16.png"]}
            animated={true}
            alertCount={Math.ceil(secondsLeft / 60)}
          />
        )}
      </div>
    );
  }
}

export default CurrentlyWorking;

// export default compose(
//   firestoreConnect(props => {
//     return [{ collection: "pomtrackers", doc: "zAUmzWCANTRolPhn33kV6HsmKmY2" }];
//   }),
//   connect(({ firestore: { data } }, props) => {
//     // console.info("currentlyworking connect");
//     // console.dir({ data, props });
//     // console.log(
//     //   data.pomtrackers &&
//     //     data.pomtrackers["zAUmzWCANTRolPhn33kV6HsmKmY2"].current_pom
//     // );
//     return {
//       currentPom:
//         data.pomtrackers &&
//         data.pomtrackers["zAUmzWCANTRolPhn33kV6HsmKmY2"] &&
//         data.pomtrackers["zAUmzWCANTRolPhn33kV6HsmKmY2"].current_pom
//     };
//   })
// )(CurrentlyWorking);



// WEBPACK FOOTER //
// ./src/components/CurrentlyWorking.js